import { registerMissingI18nKey } from "@grafit/i18n";
import { initPosthog } from "@grafit/shared/observability/analytics";
import { alertDevs, initSentry } from "@grafit/shared/observability/sentry-front";
import { getEnvironment, isProd, isProdOrPreviewEnv } from "@grafit/shared/utils/envs.front";
import { getAppVersion } from "@grafit/shared/utils/version";
import { router } from "./router";

if (isProdOrPreviewEnv()) {
  initSentry({ env: getEnvironment(), release: getAppVersion(), router });
}

registerMissingI18nKey(alertDevs);

if (isProd()) {
  initPosthog();
}
